import lazyComponent from '../../../utils/lazyComponent';

const LazyLoginPrompt = lazyComponent<Record<string, never>>(
  () => import('./LoginPrompt')
);

export default LazyLoginPrompt;
